import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./menu-item-radio.module.css";

interface MenuItemRadioProps {
    item: { label: string; value: string };
    isChecked: boolean;
    onClick: (item) => void;
}

export function MenuItemRadio({ item, isChecked, onClick }: MenuItemRadioProps): JSX.Element {
    const iconName = isChecked ? "round-radiobutton-checked" : "round-radiobutton";

    function handleClick(
        event: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>
    ): void {
        event.preventDefault();
        onClick(item);
    }

    function handleKeyDown(event: React.KeyboardEvent<HTMLAnchorElement>): void {
        if (event.key === " " || event.key === "Spacebar") {
            handleClick(event);
        }
    }

    return (
        <a
            role={"menuitemradio"}
            tabIndex={0}
            aria-checked={isChecked}
            className={clsx(styles.item, {
                [styles.itemChecked]: isChecked,
            })}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
        >
            <div
                className={clsx(styles.icon, {
                    [styles.iconChecked]: isChecked,
                })}
            >
                <SVGIcon name={iconName} />
            </div>
            <span className={styles.label}>{item.label}</span>
        </a>
    );
}
